import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import BranchesLogHeader from 'src/view/screens/BranchLogScreen/screens/BranchesLogScreen/containers/BranchesLogHeader/BranchesLogHeader';
import BranchesLogList from 'src/view/screens/BranchLogScreen/screens/BranchesLogScreen/containers/BranchesLogList/BranchesLogList';
import branchesLogStore from 'src/view/screens/BranchLogScreen/screens/BranchesLogScreen/store/branchesLogStore';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import { getBackStepPath } from '~/helpers';
import { SCREENS } from '~/constants/screens';
import LogNavigation from '~/view/components/LogNavigation/LogNavigation';

const BranchesLogScreen = (): JSX.Element => {
  const backStepPath = (): string => {
    const { id } = useParams<{ id?: string }>();

    if (id && Number(id) > 0) {
      return getBackStepPath(SCREENS.BRANCHES_EDIT(id));
    }

    return getBackStepPath(SCREENS.REPORTS());
  };

  useEffect(() => {
    branchesLogStore.fetchBranchesLogList();

    return () => {
      branchesLogStore.clear();
    };
  }, []);

  return (
    <>
      <Headers>
        <HeaderBack title="branch_log" path={backStepPath()} />
      </Headers>
      <LogNavigation />
      <div className="mt-6"></div>
      <BranchesLogHeader />
      <BranchesLogList />
    </>
  );
};

export default observer(BranchesLogScreen);
